<script setup lang="ts">
import { computed } from 'vue'
import { type UserSlim } from '../model'
import { displayText } from './User.vue'

const props = defineProps<{
  user?: UserSlim
  onClear?: (payload: PointerEvent) => void
}>()

const initials = computed(() => {
  if (!props.user) {
    return '?'
  }
  const text = props.user.displayName ?? props.user.email ?? '?'
  const localPart = text.split('@', 1)[0]
  const separatorIndex = localPart!.search(/[ ._+]/)
  const hasInitials = separatorIndex > 0 && text.length > separatorIndex
  const value = hasInitials ? text.charAt(0) + text.charAt(separatorIndex + 1) : text.substring(0, 2)
  return value.toUpperCase()
})

const style = computed(() => ({
  backgroundColor: props.user?.color ?? '#AAA'
}))
</script>

<template>
  <div
    :data-testid="`avatar-${user?.userId}`"
    class="shrink-0 rounded-full flex justify-center items-center text-white w-8 h-8 relative hover:z-10"
    :class="[onClear && 'ring-1 ring-white']"
    :style="style"
    v-tooltip.bottom="displayText(user)"
  >
    <span>{{ initials }}</span>
    <span
      v-if="onClear"
      class="absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-black"
      @click="onClear"
    >
      <i class="pi pi-times text-white text-[0.4rem]!" />
    </span>
  </div>
</template>
